
import {
  computed,
  defineComponent,
  ref,
  watch,
} from 'vue';

export default defineComponent({
  props: {
    // The page in the next app, without the /next it is served under
    path: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const frame = ref<HTMLIFrameElement>();

    const nextPath = computed(() => `/next${props.path}`);

    // The framed page keeps its filters in our hash, so a copied link opens them. Raw, not
    // route.hash: the router decodes it, and a "+" of base64 would come back as a space
    const src = nextPath.value + window.location.hash;

    // The frame moves our route itself as it navigates, so only a move from outside, a menu
    // link, reloads it. Set on the element: the bound src may already hold that very path
    watch(nextPath, (path) => {
      if (frame.value && frame.value.contentWindow?.location.pathname !== path) {
        frame.value.src = path;
      }
    });

    return {
      frame,
      src,
    };
  },
});
